module.exports = __webpack_public_path__ + "img/hshz.c6e62442.png";